/**
 * Zelleditor für Enum-Felder. Wie bei `GruppenkennzeichenEditor` schreibt `onCommit` in das
 * Modellobjekt, der lokale Zustand hält die Anzeige aktuell.
 */

import { useState } from 'react';

import { EnumDropdown } from '@/components/inputs/EnumDropdown';

export interface EnumEditorProps<T extends number> {
  value: T;
  displayNames: Record<T, string>;
  onCommit(value: T): void;
}

export function EnumEditor<T extends number>(props: EnumEditorProps<T>) {
  const [value, setValue] = useState(props.value);

  return (
    <EnumDropdown<T>
      value={value}
      onChange={(next) => {
        // Der Altclient bindet an einen nicht nullbaren Enum-Wert; Syncfusion setzt beim
        // Leeren `default(TValue)` — bei einem Enum also 0.
        const applied = (next ?? 0) as T;
        setValue(applied);
        props.onCommit(applied);
      }}
      displayNames={props.displayNames}
    />
  );
}

export default EnumEditor;
